<template>
  <v-container>
    <v-row>
      <v-col
        cols="12"
        xl="9"
        class="order-last order-xl-first"
      >
        <v-card>
          <v-card-title class="pb-8">
            <v-btn
              color="primary"
              @click="createDialog = true"
            >Nuovo cliente</v-btn>
            <v-spacer />
            <v-text-field
              v-model="search"
              append-icon="mdi-magnify"
              label="Cerca"
              single-line
              hide-details
            ></v-text-field>
          </v-card-title>
          <v-card-text>
            <v-data-table
              :headers="headers"
              :items="customers"
              :items-per-page="100"
              :search="search"
              :footer-props="{
						itemsPerPageAllText: 'Tutti',
						itemsPerPageOptions: [15, 50, 100, -1],
						itemsPerPageText: 'Clienti per pagina',
					}"
              @click:row="rowClickHandler"
            >

              <template v-slot:no-data>
                <div class="pa-3">
                  <p>Nessuna cliente trovato.</p>
                  <v-btn
                    color="primary"
                    @click="fetchCustomers"
                  >Ricarica</v-btn>
                </div>
              </template>

            </v-data-table>
          </v-card-text>
        </v-card>
      </v-col>

      <v-col>
        <customer-details :customer="selectedCustomer" />
      </v-col>
    </v-row>

    <create-dialog
      :dialog="createDialog"
      @dismiss="createDialog = false"
      @saved="savedHandler"
    />
  </v-container>
</template>

<script>
  import axios from 'axios'
  import CreateDialog from '../components/customers/CreateDialorg'
  import CustomerDetails from '../components/customers/CustomerDetails'

  export default {
    name: 'Clienti',
    components: {
      CreateDialog,
      CustomerDetails
    },

    data() {
      return {
        search: '',
        createDialog: false,
        customers: [],
        headers: [
          { text: 'Nome', value: 'name', class: 'subtitle-2 primary--text font-weight-bold' },
          { text: 'Cognome', value: 'surename', class: 'subtitle-2 primary--text font-weight-bold' },
          { text: 'Telefono', value: 'phone', class: 'subtitle-2 primary--text font-weight-bold' },
          { text: 'Email', value: 'email', class: 'subtitle-2 primary--text font-weight-bold' },
          { text: 'Codica Fiscale', value: 'fiscal_code', class: 'subtitle-2 primary--text font-weight-bold' },
          { text: '', value: 'action', class: 'subtitle-2 primary--text font-weight-bold', sortable: 'false' },
        ],
        selectedCustomer: null,
        config: {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('access_token')}`,
          },
        },
      }
    },

    methods: {
      async fetchCustomers() {
        const { data } = await axios.get(`${process.env.VUE_APP_API}/customers/fetch`, this.config)

        this.customers = data
      },

      savedHandler() {
        this.fetchCustomers()
        this.createDialog = false
      },

      rowClickHandler(item) {
        this.selectedCustomer = item
      }
    },

    mounted() {
      this.fetchCustomers()
    }

  }
</script>

<style>
</style>